exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.calendario-day{\n\twidth: 14.28%;\n\tdisplay: inline-block;\n\ttext-align: center;\n\tfont-size: 10px;\n}\n.calendario-label-day {\n\tcolor: #17202a;\n\tdisplay: block;\n\tborder-radius: 4px;\n}\n.calendario-label-day:hover {\n\tcolor: #17202a;\n\tbackground-color: #abb2b9;\n}\n.calendario-label-select{\n\tbackground-color: #abb2b9;\n}\n.calendario-label-today {\n\tbackground-color: #cb4335;\n\tcolor: #fff;\n}\n.calendario-name-day{\n\tdisplay: block;\n\tfont-weight: 700;\n\tcolor: #566573;\n}\n", ""]);

// exports
